import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    *, *:after, *:before {
        margin: 0px;
        padding: 0px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        font-family: "Poppins";
    }
    
    body {
        width:100%;
        background: ${({ theme }) => theme.background};
        color: ${({ theme }) => theme.text};
        transition: 0.2s background ease-in-out;
    }

    p {
        font-size: 1.1rem;
        color: ${({ theme }) => theme.text};

        @media screen and (max-width: 767px) {
        font-size: 1rem;
        }

        @media screen and (max-height: 600px) {
        font-size: 0.9rem;
        }
    }

    svg {
    display: block;
  }

`;

export default GlobalStyles;
